import type { ProgressBarProps } from './ProgressBar.types';
import { Wrapper, Track, Bar, Mark, MarkLabel } from './ProgressBar.parts';

export function ProgressBar(props: ProgressBarProps) {
	return (
		<Wrapper hasMark={!!props.mark}>
			<Track>
				<Bar
					width={(props.value / props.max) * 100}
					animateDuration={props.animateDuration}
					animateReverse={props.animateReverse}
				/>
				{props.mark && (
					<Mark
						start={(props.mark.from / props.max) * 100}
						width={((props.mark.to - props.mark.from) / props.max) * 100}
					>
						<MarkLabel align={props.mark.labelAlign}>{props.mark.label}</MarkLabel>
					</Mark>
				)}
			</Track>
		</Wrapper>
	);
}
